import { Highlight, themes } from "prism-react-renderer";
import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import HeaderCard from "../../Common/HeaderCard";
import { Javadata } from "./Data";

const JavascriptMode = () => {
  return (
    <Fragment>
      <Col xl="6">
        <Card>
          <HeaderCard title={"Javascript Mode"} />
          <CardBody>
            <Highlight theme={themes.vsDark} code={Javadata} language="javascript">
              {({ style, tokens, getLineProps, getTokenProps }) => (
                <pre style={style}>
                  {tokens.map((line, i) => (
                    <div key={i} {...getLineProps({ line })}>
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default JavascriptMode;
